module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_2.e329df8d.pdf";